import {
    PRODUTO_MODO_TELA,
    PRODUTO_SET_AGUARDANDO,
    PRODUTO_LISTADO
} from './produtoActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PRODUTO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case PRODUTO_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case PRODUTO_LISTADO: {
            const lista = action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };
        }

        default:
            return state;
    }
};